import { today } from './dates';

/** The day open on the timeline, so the + button adds to that day. */
let selected = today();
export const getSelectedDay = () => selected;
export const setSelectedDay = (d: string) => { selected = d; };
